/**
 * @generated SignedSource<<fdfa439037981d0c12932355b79434ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadItem_Contact$data = {
  readonly __typename: string;
  readonly name?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"RecipientAvatar_Recipient" | "chat_useContactDescription">;
  readonly " $fragmentType": "ChatThreadItem_Contact";
};
export type ChatThreadItem_Contact$key = {
  readonly " $data"?: ChatThreadItem_Contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadItem_Contact">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatThreadItem_Contact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "ChatBot",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecipientAvatar_Recipient"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "chat_useContactDescription"
    }
  ],
  "type": "Recipient",
  "abstractKey": "__isRecipient"
};
})();

(node as any).hash = "109acba0b00684377823a31b00532bc7";

export default node;
